import {SearchGroupIcon} from 'components/AppIcon'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import {NavigationContext} from 'modules/navigation/NavigationContext'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useContext} from 'react'
import {staticPaths} from 'routes/staticPaths'
import DiscoveryExplorerContext from 'views/DiscoveryExplorer/DiscoveryExplorerContext'
import {NullAsDefault, renderOwnChild} from 'views/Shared'
import {AppEntities, customLabels, fromAppEntity} from '../enums'
import classNames from "classnames"
import WordsOfGod from "../WoG/WordsOfGod";
import preventDefaultEvent from "../../../helpers/preventDefaultEvent";
import queryString from 'query-string'
import {RequiredSystemAdmin} from "../../../components/RequiredAdmin";
import {copyLocationParam} from "../../../envs/_current/history";

const renderDefaultItem = (type, {onClick}) => {
    if (_.isEmpty(type)) return null
    return (
        <Translate>
            {(t) => (
                <div
                    onClick={onClick}
                    style={{height: '8rem'}}
                    className="flex flex-col items-center justify-center gap-2 rounded-lg hover:shadow-out text-color-000 hover:text-primary cursor-pointer background-100">
                    <SearchGroupIcon
                        type={type}
                        size={30}
                        className="text-primary-500"
                    />
                    <span className="font-semibold md:font-medium text-center text-xs">{t(type)}</span>
                </div>
            )}
        </Translate>
    )
}

export const renderFeatureItem = (type, {onClick = NullAsDefault, className = "", color, size}) => {

    if (_.isEmpty(type)) return null
    return (
        <Translate>
            {(t) => (
                <div
                    onClick={onClick}
                    style={{height: '6rem'}}
                    className={classNames(
                        "flex flex-col flex-center gap-2 border border-color-50 rounded-lg hover:shadow-items text-color-000 hover:text-primary cursor-pointer",
                        className
                    )}>
                    <SearchGroupIcon
                        type={type}
                        size={size ? size : 25}
                        className={color ? color : "text-primary-500"}
                    />
                    <span className="text-center font-semibold md:font-medium text-sm md:text-xs text-color-000">
            {t(customLabels[type] ?? type)}
          </span>
                </div>
            )}
        </Translate>
    )
}

const Explorer = ({
                      type,
                      path,
                      search,
                      pathname,
                      renderItem,
                      Wrapper = renderOwnChild,
                  }) => {
    const history = useHistory()
    const {setFilter = NullAsDefault} = useContext(DiscoveryExplorerContext)
    const onSelect = () => {
        if (path) {
            setFilter({})
            history.push(path)
        }
    }
    return (
        <Wrapper>
            {renderItem(type, {
                onClick: onSelect,
            })}
        </Wrapper>
    )
}

const createDiscoveryExplorer = ({
                                     entity,
                                     renderItem = renderDefaultItem,
                                     ...props
                                 }) => {
    const type = fromAppEntity(entity, 'pathname')

    return (
        <Explorer
            {...props}
            type={type}
            renderItem={renderItem}
        />
    )
}

export const GeneralExplorer = (props) =>
    createDiscoveryExplorer({
        entity: AppEntities.UNDEFINED,
        renderItem: renderFeatureItem,
        ...props,
    })

export const CodiDocumentExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(props.path)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const CodiDocumentRowExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(props.path)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const KeywordExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(props.path)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const DefinitionExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(props.path)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const EcclesiasticDocumentExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(props.path)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const AskExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(staticPaths.discussions)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const EventExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(props.path)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const PilgrimageExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(staticPaths.pilgrimage)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const EvangelizationExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(staticPaths.evangelization)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const ChannelExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(props.path)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const OrganizationExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(staticPaths.organizations)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const UserExplorer = (props) =>
    createDiscoveryExplorer({
        entity: AppEntities.USER,
        renderItem: renderFeatureItem,
        ...props,
    })

export const ArticleExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(props.path)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const ExaminationExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(props.path)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const CourseExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(staticPaths.edu)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const MusicExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(props.path)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const LiturgyExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(staticPaths.calendar)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const ChurchExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(staticPaths.churches)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const DivineWordExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) => (
            <WordsOfGod>
                {renderFeatureItem(props.type, {
                    size: props.size,
                    color: props.color,
                    onClick: (e) => {
                        history.push({
                            // ...window.location,
                            ...copyLocationParam(window.location ?? {}),
                            search: queryString.stringify(
                                {
                                    popup: 'divine-word'
                                },
                                {arrayFormat: 'comma'}
                            )
                        })
                        e && preventDefaultEvent(e)
                    }
                })}
            </WordsOfGod>
        )}
    </NavigationContext.Consumer>
)

export const BiblesExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push({pathname: staticPaths.documentLibrary.pathname, search: '?view=bible'})
                },
            })
        }
    </NavigationContext.Consumer>
)

export const ProfilesExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(staticPaths.profiles)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const SaintsExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(staticPaths.saints)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const PrelatesExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(staticPaths.prelates)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const YellowPageExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(staticPaths.yellowPages)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const MassTimeExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(staticPaths.churches)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const DiocesesExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(staticPaths.dioceses)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const MissalsExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(staticPaths.missals)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const ReligiousOrdersExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(staticPaths.religiousOrder)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const FeedbackExplorer = (props) => (
    <RequiredSystemAdmin>
        <NavigationContext.Consumer>
            {({history}) =>
                renderFeatureItem(props.type, {
                    color: props.color,
                    onClick: () => {
                        history.push(staticPaths.feedbacks)
                    },
                })
            }
        </NavigationContext.Consumer>
    </RequiredSystemAdmin>
)

export const CatechismExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(props.path)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const CanonLawExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(props.path)
                },
            })
        }
    </NavigationContext.Consumer>
)

export const VaticanIIExplorer = (props) => (
    <NavigationContext.Consumer>
        {({history}) =>
            renderFeatureItem(props.type, {
                color: props.color,
                onClick: () => {
                    history.push(props.path)
                },
            })
        }
    </NavigationContext.Consumer>
)

export default createDiscoveryExplorer
